import { useState, type ReactNode } from 'react';

import type { AuthUser } from '@/modules/auth/types';
import { TenantContextBanner } from '@/shared/components/TenantContextBanner';
import { DashboardHeader } from '@/shared/layout/DashboardHeader';
import { DashboardPageContent } from '@/shared/layout/DashboardPageContent';
import { DashboardSidebar } from '@/shared/layout/DashboardSidebar';

interface AppShellProps {
  user: AuthUser;
  children: ReactNode;
}

export function AppShell({ user, children }: AppShellProps) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const isSuperAdmin = user.roles.includes('super_admin');

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="h-1 w-full" style={{ background: 'var(--warning)' }} aria-hidden />
      <TenantContextBanner />
      <div className="flex min-h-[calc(100vh-4px)]">
        <DashboardSidebar
          isSuperAdmin={isSuperAdmin}
          mobileOpen={mobileNavOpen}
          onClose={() => setMobileNavOpen(false)}
        />
        <div className="flex min-w-0 flex-1 flex-col">
          <DashboardHeader user={user} onMenuClick={() => setMobileNavOpen(true)} />
          <main className="flex-1 overflow-auto p-4 sm:p-5 md:p-6">
            <DashboardPageContent>{children}</DashboardPageContent>
          </main>
        </div>
      </div>
    </div>
  );
}
